import React, { useEffect } from "react";
import {
  View,
  Text,
  ImageBackground,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import { GAME_SERVICE } from "../constants/api";

const Waiting = ({
  tableId,
  userId,
  handHistoryId,
  replay,
}) => {
  console.log(
    "props on waiting",
    tableId,
    userId,
    handHistoryId,
    replay
  );

  useEffect(() => {
    let interval;

    const checkReplayVideo = async () => {
      try {
        if (!handHistoryId || !userId) return;

        const response = await fetch(
          `${GAME_SERVICE}/v1/hand-history/replay-by-user/${handHistoryId}/${userId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
            redirect: "follow",
          }
        );

        const result = await response.json();

        console.log("replay response:", result);

        if (
          response.status === 200 &&
          result?.status === 200 &&
          result?.data?.replayVideo
        ) {
          const videoUrl = result.data.replayVideo;

          window.location.href =
            videoUrl;
        }
      } catch (error) {
        console.log("Replay API error:", error);
      }
    };

    checkReplayVideo();

    interval = setInterval(() => {
      checkReplayVideo();
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, [handHistoryId, userId]);

  return (
    <View style={styles.container}>
      <ImageBackground
        source={require("../../src/assets/inGameAssets/waiting.jpg")}
        style={styles.bg}
        resizeMode="cover"
      >
        <View style={styles.overlay}>
          <ActivityIndicator size="large" color="#dcdcdc" />

          <Text style={styles.loadingText}>
            Loading....
          </Text>
        </View>
      </ImageBackground>
    </View>
  );
};

export default Waiting;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },

  bg: {
    flex: 1,
    width: "100%",
    height: "100%",
  },

  overlay: {
    flex: 1,
    marginTop: "70%",
    justifyContent: "center",
    alignItems: "center",
  },

  loadingText: {
    color: "#dcdcdc",
    marginTop: 14,
    fontSize: 16,
    fontWeight: "600",
  },
});